import React from "react";
import { Reveal } from "@/components/motion/Reveal";
import { Eyebrow, Button } from "@/components/kit";
import { Search, PenTool, Rocket, LineChart } from "lucide-react";

const steps = [
  {
    icon: Search,
    n: "01",
    kicker: "Dag 1 · Gratis",
    title: "Growth Scan & strategie",
    body: "We starten met luisteren. De AI Growth Scan of een gesprek legt bloot waar je omzet blijft liggen — zonder aannames of sjablonen.",
  },
  {
    icon: PenTool,
    n: "02",
    kicker: "Week 1 · Vaste prijs",
    title: "Blauwdruk & fundament",
    body: "Een concreet 90-dagen plan: kanalen, boodschap, budget en KPI's. Plus een snel, SEO-proof fundament (website, funnel, tracking).",
  },
  {
    icon: Rocket,
    n: "03",
    kicker: "Doorlopend",
    title: "Campagnes & content",
    body: "AI-versnelde uitvoering met menselijke hand: advertenties, SEO-content en creatives die converteren — wekelijks bijgestuurd.",
  },
  {
    icon: LineChart,
    n: "04",
    kicker: "Elke maand",
    title: "Optimaliseren & schalen",
    body: "We verdubbelen wat werkt en snijden wat niet werkt. Maandelijks een eerlijk gesprek met heldere cijfers — geen ruis.",
  },
];

const HowWeWork = () => (
  <section
    id="hoe-wij-werken"
    data-testid="how-we-work-section"
    className="relative bg-ivory py-24 lg:py-32"
  >
    <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 items-end mb-14 lg:mb-20">
        <div className="lg:col-span-8">
          <Eyebrow>Werkwijze · In 4 stappen</Eyebrow>
          <h2 className="mt-6 font-display font-black text-coal tracking-tight leading-[0.95] text-4xl sm:text-5xl lg:text-6xl">
            Van eerste gesprek<br className="hidden sm:block" /> tot <span className="text-gradient-blue">meetbare groei.</span>
          </h2>
        </div>
        <div className="lg:col-span-4 lg:text-right">
          <p className="text-coal/60 leading-relaxed mb-5 max-w-sm lg:ml-auto">
            Een heldere aanpak zonder verrassingen. Je weet vóór de start precies wat je krijgt.
          </p>
          <Button to="/ai-scan" variant="primary" withArrow testid="how-we-work-cta">
            Start bij stap 1
          </Button>
        </div>
      </div>

      <ol className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5 lg:gap-6">
        {steps.map((s, i) => {
          const Icon = s.icon;
          return (
            <Reveal as="li" key={s.n} delay={i * 0.08}>
              <div
                data-testid={`how-step-${i}`}
                className="group h-full rounded-[1.5rem] border border-ivory-400 bg-white p-7 hover:border-electric/40 hover:shadow-card-lift transition-all duration-300"
              >
                <div className="flex items-center justify-between mb-6">
                  <div className="w-11 h-11 rounded-xl bg-electric/10 border border-electric/15 grid place-items-center text-electric group-hover:bg-electric group-hover:text-white transition-colors duration-300">
                    <Icon className="w-5 h-5" />
                  </div>
                  <span className="font-display font-black text-3xl text-ivory-500">{s.n}</span>
                </div>
                <div className="font-mono text-[10px] uppercase tracking-[0.22em] text-electric mb-2">
                  {s.kicker}
                </div>
                <h3 className="font-display font-bold text-xl text-coal mb-3 leading-tight">
                  {s.title}
                </h3>
                <p className="text-[15px] text-coal/60 leading-relaxed">{s.body}</p>
              </div>
            </Reveal>
          );
        })}
      </ol>
    </div>
  </section>
);

export default HowWeWork;
